import React from 'react';
import { Button, Collapse } from '@material-ui/core';
import {  FileCopyOutlined as ContentCopyIcon, CheckCircle, BugReport, ExpandMore, ExpandLess } from '@material-ui/icons';
import {
  extractComponentName,
  extractMethodName,
  formatErrorReport,
  copyErrorToClipboard as copyErrorToClipboardUtil,
  reportError as reportErrorUtil
} from '../../utils/errorUtils';
import {
  getCommonCustomFields,
  isFreshworksWidgetAvailable
} from '../../../utilities/freshDeskUtils';

class ErrorDetailsSection extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showDetails: false,
      copiedToClipboard: false
    };
    this.copyTimeout = null;
  }

  componentWillUnmount() {
    if (this.copyTimeout) {
      clearTimeout(this.copyTimeout);
    }
  }

  toggleErrorDetails = () => {
    this.setState((prevState) => ({
      showDetails: !prevState.showDetails
    }));
  };

  copyErrorToClipboard = async () => {
    const errorReport = formatErrorReport({
      error: this.props.error,
      errorInfo: this.props.errorInfo,
      errorId: this.props.errorId,
      reportType: this.props.reportType || 'Error Report'
    });

    const success = await copyErrorToClipboardUtil(errorReport);
    if (success) {
      this.setState({ copiedToClipboard: true });
      if (this.copyTimeout) {
        clearTimeout(this.copyTimeout);
      }
      this.copyTimeout = setTimeout(() => {
        this.setState({ copiedToClipboard: false });
      }, 2000);
    }
  };

  reportError = () => {
    const errorReport = formatErrorReport({
      error: this.props.error,
      errorInfo: this.props.errorInfo,
      errorId: this.props.errorId,
      reportType: this.props.reportType || 'Error Report'
    });
    const errorReportTitle = `${this.props.reportType || 'Error Report'} - ${this.props.errorId}`;

    reportErrorUtil(
      errorReport,
      errorReportTitle,
      isFreshworksWidgetAvailable,
      getCommonCustomFields
    );
  };

  render() {
    const {
      classes,
      error,
      errorInfo,
      errorId,
      showReportButton = true,
      showToggleButton = true
    } = this.props;
    const { showDetails, copiedToClipboard } = this.state;

    return (
      <>
        <Collapse in={showDetails}>
          <div className={classes.errorDetailsContainer}>
            <div className={classes.actionButtons}>
              <Button
                variant="contained"
                size="small"
                className={classes.copyButton}
                onClick={this.copyErrorToClipboard}
                startIcon={copiedToClipboard ? <CheckCircle /> : <ContentCopyIcon />}>
                {copiedToClipboard ? 'Copied!' : 'Copy Error'}
              </Button>
            </div>
            <div className={`${classes.errorDetails} customScroll`}>
              <div>
                <strong>Error ID:</strong> {errorId}
                <br />
                <strong>URL:</strong> {window.location.href}
                <br />
                <strong>Timestamp:</strong> {new Date().toISOString()}
              </div>
              {error && (
                <div>
                  {errorInfo?.componentStack && (
                    <div>
                      <strong>Component Name:</strong>{' '}
                      {extractComponentName(errorInfo.componentStack)}
                    </div>
                  )}
                  {error?.stack && (
                    <div>
                      <strong>Method Name:</strong> {extractMethodName(error.stack)}
                    </div>
                  )}
                  <strong>Error Type:</strong> {error.name}
                  <br />
                  <strong>Error Message:</strong> {error.message}
                  <br />
                  <strong>Full Error:</strong> {error.toString()}
                </div>
              )}
              {error?.stack && (
                <div>
                  <strong>Stack Trace:</strong>
                  <pre>{error.stack}</pre>
                </div>
              )}
              {errorInfo?.componentStack && (
                <div style={{ marginTop: 8 }}>
                  <strong>Component Stack:</strong>
                  <pre>{errorInfo.componentStack}</pre>
                </div>
              )}
            </div>
          </div>
        </Collapse>

        {showToggleButton && (
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginTop: 16 }}>
            <Button
              color="primary"
              variant="text"
              classes={{ root: classes.toggleDetailsButton }}
              onClick={this.toggleErrorDetails}
              endIcon={showDetails ? <ExpandLess /> : <ExpandMore />}>
              {showDetails ? 'Hide' : 'Show'} Error Details
            </Button>
            {showReportButton && (
              <Button
                variant="contained"
                size="small"
                className={classes.reportButton}
                onClick={this.reportError}
                startIcon={<BugReport />}>
                Report Error
              </Button>
            )}
          </div>
        )}
      </>
    );
  }
}

export default ErrorDetailsSection;
